import React from 'react';
import { Box, Button, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { INK, YELLOW } from '../constants';
import styles from './QuizCta.module.scss';

/** Ink quiz callout (Fi Yellow reserved for this CTA). */
export const QuizCta: React.FC<{ onLaunch: () => void }> = ({ onLaunch }) => {
  const { t } = useTranslation();
  return (
    <Stack align="center" spacing={14} bg={INK} c="#fff" ta="center" className={styles.cta}>
      <Box component="span" fw={700} c={YELLOW} tt="uppercase" lts="0.72px" className={styles.eyebrow}>
        {t('compare_v2_quiz_eyebrow')}
      </Box>
      <Box component="h2" m={0} fw={700} lts="-0.02em" className={styles.title}>
        {t('compare_v2_quiz_title')}
      </Box>
      <Text c="rgba(255, 255, 255, 0.72)" maw={460} lh={1.5} className={styles.subtitle}>
        {t('compare_v2_quiz_subtitle')}
      </Text>
      <Button
        color="fi-yellow"
        radius={999}
        mt={8}
        onClick={onLaunch}
        styles={{
          root: { height: 'auto', padding: '16px 42px' },
          label: { color: INK, fontSize: 15, fontWeight: 700, letterSpacing: '-0.14px' },
        }}
      >
        {t('compare_v2_quiz_cta')}
      </Button>
    </Stack>
  );
};
